// Runs async jobs a few at a time.
//
// The two alternatives both hurt at the sizes the reports reach: awaiting in a loop turns N
// reads into N round trips, and Promise.all over the whole list opens N connections at once,
// which the Firestore SDK then queues anyway while the tab stalls.
//
// Never rejects. Every job is settled independently and reported as { value } or { error }, in
// the same order as the jobs were given, so one failed read cannot lose the other results.

export const runPool = async (jobs, size, onSettled) => {
  const list = jobs || []
  const results = new Array(list.length)
  let next = 0

  const worker = async () => {
    while (next < list.length) {
      const index = next
      next += 1
      try {
        results[index] = { value: await list[index]() }
      } catch (error) {
        results[index] = { error }
      }
      if (onSettled) onSettled(results[index], index)
    }
  }

  const width = Math.max(1, Math.min(size || 1, list.length))
  await Promise.all(Array.from({ length: width }, worker))
  return results
}

export default runPool
